import styled from 'styled-components'

export const InfluencerIdentityRowValueAndLabelRoot = styled.div`
  text-align: center;
  ${({ width }) => `width: ${width}rem`}
`
